import i18n from '../i18n/i18n';
import { LanguageService } from '../Axios/Api';
import { setCurrentLanguage } from '../Axios/axiosInstance';

const LANGUAGE_STORAGE_KEY = 'selectedLanguage';
const DIRECTION_STORAGE_KEY = 'selectedDirection';

const applyLanguage = (code, direction) => {
  // Persist for axios headers and future sessions
  setCurrentLanguage(code);
  if (direction) {
    localStorage.setItem(DIRECTION_STORAGE_KEY, direction);
  }
  // Apply immediately
  i18n.changeLanguage(code);
  if (direction) {
    document.documentElement.dir = direction;
  }
  document.documentElement.lang = code;
};

export const bootstrapLanguage = async () => {
  try {
    const storedCode = localStorage.getItem(LANGUAGE_STORAGE_KEY);
    const storedDir = localStorage.getItem(DIRECTION_STORAGE_KEY);

    if (storedCode) {
      // Use stored language (dir may be null for legacy data)
      applyLanguage(storedCode, storedDir || (document.documentElement.dir || 'ltr'));
      return;
    }

    // Fetch available languages to determine default
    const response = await LanguageService.getLanguages();
    const languages = response?.result || [];
    const defaultLang = languages.find(lang => lang?.isDefault) || languages[0];

    const code = defaultLang?.code || 'en';
    const direction = defaultLang?.direction || 'ltr';
    // applyLanguage(code, direction);
    applyLanguage('ar', 'rtl');
  } catch (_e) {
    // Fallback to English without blocking app start
    applyLanguage('en', 'ltr');
  }
};

export default bootstrapLanguage;

